// import FavoritePreview from '@app/Likes/Preview'
import UnFavoritePreview from '@app/Likes/UnPreview'

import AddToFavorites from '@app/Likes/Add'
import FavoriteView from '@app/Likes/View'

export default function install(Vue) {
  Vue.component(UnFavoritePreview.name, UnFavoritePreview)
  // Vue.component(FavoritePreview.name, FavoritePreview)
  Vue.component('AddToFavorites', AddToFavorites)
  Vue.component(FavoriteView.name, FavoriteView)
}
